import {Typography} from '../Typography';

import type {ReactNode} from 'react';

export interface FormSectionHeadingProps {
  title: string;
  description?: string;
  trailing?: ReactNode;
  titleSize?: 'sm' | 'md';
}

export function FormSectionHeading({
  title,
  description,
  trailing,
  titleSize = 'md'
}: FormSectionHeadingProps) {
  return (
    <div data-slot="form-section-heading" className="flex items-center justify-between">
      <div className="flex flex-col gap-0.5">
        <Typography as="h2" size={titleSize} weight="semibold">
          {title}
        </Typography>
        {description && (
          <Typography as="p" size="sm" color="tertiary">
            {description}
          </Typography>
        )}
      </div>
      {trailing}
    </div>
  );
}
